import React, { useState, useRef } from 'react';
import { Button, Card, CardBody, FormGroup, Label, Row, Col } from 'reactstrap';
import { Formik, Field, Form } from 'formik';
import { useParams } from 'react-router';
import * as Yup from 'yup';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';
import FormikInputField from 'components/common/Fields/FormikInputField';
import API from 'utils/API';
import Loader from 'components/Loader';
import { PatientComment, RxComment } from 'components/Comments';

const validationSchema = Yup.object({
  comment: Yup.string().required('Comment is required'),
});

let blobFiles = [];

const Comments = (props) => {
  const { rxNumber, hasEditable = true, onClose } = props;
  const { patientId, tenantID, coveredEntityID } = useParams();
  const [submitting, setSubmitting] = useState(false);
  const patientID = parseInt(patientId);

  const [files, setFiles] = useState([]);
  const formikRef = useRef();

  const addComment = async (payload, actions) => {
    try {
      let url = `/${tenantID}/Comments`,
        variables = { ...payload, ceid: coveredEntityID };
      if (rxNumber) {
        url = `${url}/AddRxComment`;
        variables.rxNumber = parseInt(rxNumber);
      } else {
        url = `${url}/AddPatientComment`;
        variables.patientId = patientID;
      }
      const data = await API.post(url, variables, {
        headers: {
          'Content-type': 'multipart/form-data',
        },
      });
      if (data.status === 200) {
        setFiles([]);
        blobFiles = [];
        toast.success('Comment added successfully!');
        actions.resetForm();
        setSubmitting(false);
        onClose();
      } else {
        setSubmitting(false);
        setFiles([]);
        blobFiles = [];
      }
    } catch (error) {
      console.log(error, 'error');
      setSubmitting(false);
    }
  };

  const handleSubmit = async (values, actions) => {
    const { comment } = values;
    const { setErrors } = formikRef.current;
    if (!comment.trim()) return setErrors({ comment: 'Enter valid comment' });
    const fileObject = {};
    files.map((f, i) => {
      fileObject['file' + (i + 1)] = f;
      return f;
    });
    setSubmitting(true);
    addComment({ comment, ...fileObject }, actions);
  };

  const fileToDataUri = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
      };
      reader.readAsDataURL(file);
    });

  const handleFiles = (f) => {
    setFiles([...files, ...f]);
  };

  const onHandleFileChange = (e) => {
    const files = e;
    handleFiles(files);
    files.forEach((data) => {
      fileToDataUri(data).then((dataUri) => {
        blobFiles.push(dataUri);
      });
    });
  };

  return (
    <>
      {hasEditable && (
        <Card className="border-0 rounded shadow-top">
          {submitting && <Loader opacity={0.01} color="black" />}
          <CardBody>
            <Formik
              initialValues={{
                comment: '',
                files: [],
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              innerRef={formikRef}
              children={(props) => {
                return (
                  <Form>
                    <Row>
                      <Col sm="6">
                        <FormGroup>
                          <Field
                            id="Comment"
                            name="comment"
                            type="textarea"
                            component={FormikInputField}
                            label="Comment"
                            placeholder="Comment"
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup>
                          <Label>Attachment</Label>
                          <Dropzone onDrop={onHandleFileChange}>
                            {({
                              getRootProps,
                              getInputProps,
                              isDragActive,
                            }) => (
                              <section
                                className={`drop-zone ${isDragActive ? 'active' : ''
                                  }`}
                              >
                                <div {...getRootProps()}>
                                  <input {...getInputProps()} />
                                  <div className="browse">
                                    <span>Drag and drop attachment or</span>
                                    <span className="highlight">Browse</span>
                                  </div>
                                </div>
                              </section>
                            )}
                          </Dropzone>
                          {files?.length > 0 && (
                            <div>
                              {files.map((item) => {
                                return <div key={item.name}>{item.name}</div>;
                              })}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end align-items-center">
                      <div>
                        <Button
                          color="primary"
                          type="submit"
                          size="sm"
                          disabled={submitting}
                        >
                          Add
                        </Button>
                      </div>
                    </div>
                  </Form>
                );
              }}
            ></Formik>
          </CardBody>
        </Card>
      )}
      <Card className="border-0 rounded-bottom-1 mt-3 table-card">
        <CardBody>
          {rxNumber ? <RxComment
            rxNumber={rxNumber}
            patientID={patientID}
            tenantID={tenantID}
            coveredEntityID={coveredEntityID}
            text="Comments"
          /> :
            <PatientComment
              patientID={patientID}
              tenantID={tenantID}
              coveredEntityID={coveredEntityID}
              text="Comments"
            />
          }
        </CardBody>
      </Card>
    </>
  );
};

export default Comments;
